module.exports = __webpack_public_path__ + "static/media/Japan_Costa_rica.38070d25.jpeg";